import React from 'react'

import { Cognito } from 'components/auth/Cognito'
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { StyledButton } from 'components/common/PrimaryButton'

type GoogleButtonProps = {
  title: string
}

export const GoogleButton: React.FC<GoogleButtonProps> = ({ title }) => (
  <StyledButton
    onClick={() => {
      Cognito.federatedSignIn({
        provider: CognitoHostedUIIdentityProvider.Google,
      })
    }}
  >
    <FontAwesomeIcon className="mr-2" icon={['fab', 'google']} /> { title }
  </StyledButton>
)
